export const debounce = (callback, wait) => {
  let timerId;

  const r = (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      callback(...args);
    }, wait);
  };

  r.cancel = () => {
    clearTimeout(timerId);
  };

  return r;
};
